import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/productSearch"
import { SALES_SEARCH_LIMIT } from "../constants"
import type { SalesProduct } from "../types"

import { ComputedProductStatus, GetSalesProductListDocument } from "@/graphql/codegen/graphql"

interface UseGetSalesProductsParams {
  searchQuery: string
  productId?: number
}

interface UseGetSalesProductsReturn {
  products: SalesProduct[]
  isFetching: boolean
}

export const useGetSalesProducts = ({
  searchQuery,
  productId,
}: UseGetSalesProductsParams): UseGetSalesProductsReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetSalesProductListDocument,
    variables: {
      input: {
        filter: {
          query: productId ? undefined : searchQuery,
          productIds: productId ? [String(productId)] : undefined,
          computedProductStatuses: [ComputedProductStatus.Active],
        },
        limit: SALES_SEARCH_LIMIT,
        offset: 0,
      },
    },
    pause: !productId && !searchQuery,
  })

  const products = useMemo(() => {
    if (data?.product?.list?.__typename === "ProductListSuccess") {
      return data.product.list.products
    }
    return []
  }, [data])

  return { products, isFetching: fetching }
}
